import { ArrowPathIcon, XCircleIcon } from '@heroicons/react/24/outline';
import { FilterItem } from './filter';

export const BehaviorFilters: FilterItem[] = [
  {
    id: 'normal',
    name: 'عادی'
  },
  {
    id: 'abandoned',
    name: 'برمیگردم!',
    icon: <ArrowPathIcon width={18} height={18} className='inline text-blue-500' />
  },
  {
    id: 'will_return',
    name: 'ولش کن!',
    icon: <XCircleIcon width={20} height={20} className='inline text-red-500' />
  }
];
